// Advisors page component
export function AdvisorsPage() {
  return `
    <div class="min-h-screen bg-gray-50">
      <div class="hero">
        <div class="hero-content">
          <h1 class="hero-title">Todos los asesores de certificados energéticos</h1>
          <p class="hero-subtitle">en España</p>
        </div>
      </div>

      <section class="section bg-gray-50">
        <div class="container">
          <div class="max-w-6xl mx-auto prose prose-lg">
            <!-- Responsive two-column layout: stacks on small screens, side-by-side on md+ -->
            <div class="flex flex-col md:flex-row md:items-start md:space-x-8">
              <!-- Left column: intro text -->
              <div class="bg-white p-8 rounded-lg shadow-sm md:w-2/3">
                <h2 class="text-2xl text-blue-900 mb-4">Todos los asesores de certificados energéticos</h2>
                <p class="mb-4">Aquí encontrarás a todos los asesores de certificados energéticos afiliados a CEEcasasespaña.com.
CEEcasasespaña.com ofrece la comparación más completa de asesores de certificación energética en España.

Todos los asesores que ves aquí están reconocidos, certificados y oficialmente registrados en el Ministerio para la Transición Ecológica y el Reto Demográfico (MITECO).
Además, en CEEcasasespaña.com trabajamos con entidades de certificación acreditadas que garantizan la calidad, precisión y fiabilidad de las certificaciones energéticas realizadas según la legislación española (Real Decreto 390/2021).

De este modo, siempre tendrás la seguridad de que tu certificado energético será emitido por un experto cualificado y fiable, cumpliendo plenamente con las normas oficiales de calidad de España.</p>
              </div>

              <!-- Right column: card -->
              <div class="p-8 rounded-lg shadow-sm md:w-1/3" style="background: linear-gradient(335deg, rgba(63, 137, 233, 0.85), rgba(121, 211, 238, 0.75));">
              <img src="/images/team/compare.webp" alt="Comparar asesores de certificados energéticos" class="mb-4 w-full h-auto rounded-md object-cover" />  
              <p class="mb-4">Compara asesores de certificados energéticos.
Compara precios, calidad y rapidez según tus necesidades.</p>

                <p><a href="/cadastro/" data-route="/cadastro/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Comparar ahora -></a></p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <!-- New advisors grid card -->
      <section class="section bg-gray-50">
        <div class="container">
          <div class="max-w-6xl mx-auto">
            <div class="p-8 rounded-lg shadow-sm" style="background: linear-gradient(335deg, rgba(63, 137, 233, 0.85), rgba(121, 211, 238, 0.75));">
              <h3 class="text-xl text-blue-900 mb-6">Asesores</h3>
              <!-- 6 columns x 6 rows grid -->
              <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
                ${Array.from({ length: 36 })
              .map((_, i) => {
                // Map indices 0..23 to partner_logo_1.webp .. partner_logo_24.webp
                const idx = i + 1; // 1-based
                const src = idx >= 1 && idx <= 36 ? `/images/advisors/partner_logo_${idx}.webp` : '/images/advisors/partner_label.webp';
                return `
              <div class="flex items-center justify-center p-4 bg-white border rounded-md">
                <img src="${src}" alt="partner" class="max-h-16 object-contain opacity-90" />
              </div>
            `
              })
              .join('')}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  `;
}
